export default __webpack_public_path__ + "static/media/tdk.b091605e.png";